import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import { bmxurl, ConvertDateToDB } from 'src/globals';
import { getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BusyService } from '../../_services/busy.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../../_services/global.service';
import { MenuItem } from 'primeng/api';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';
import { cColumninfo } from 'src/types/columninfo';
import { tag_returndata } from 'src/types/tag_returndata';
import { tag } from 'src/types/tag';

@Component({
  selector: 'app-bookinganswersreport',
  templateUrl: './bookinganswersreport.component.html',
  styleUrls: ['./bookinganswersreport.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BookinganswersreportComponent  implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;
  PreviousBookingDate: Date;
  hubConnection: HubConnection;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  PreviousHubs: string[] = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  guests: number = 0;
  total: number = 0;
  outstanding: number = 0;

  cols: any[] = [];

  //What each admission column adds up to over the period, by the column's field. Filled in by
  //splitAdmissions and read by the footer.
  admissionTotals: { [field: string]: number } = {};

  //The report runs over a period now rather than a single day, and can be narrowed by tag -
  //the same choices, and the same request, as the Booking List report.
  FromDate: Date = new Date();
  ToDate: Date = new Date();
  tags: tag[] = [];
  chosentags: tag[] = [];

  //Sent as the request's created flag. See loadgrid for what it is and why it is fixed here.
  readonly REPORTONCREATEDDATE: boolean = false;

  constructor(
    private http: HttpClient,
    private appComp: AppComponent,
    private router: Router,
    private messageService: MessageService,
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService) {

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        // if(getAccess("EXTRAS", user)){
        //   this.AccessAllowed = true;
        // }
        // else
        // {
        //   this.AccessAllowed = false;
        // }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
    }

  ngOnDestroy() {
    this.hubConnection.stop();
  }

  showInProgress(){
    this.inProgress = true;
    this.loadgrid(false);
  }

  unshowInProgress(){
    this.inProgress = false;
    this.loadgrid(false);
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("EXTRAS", user)){
          this.AccessAllowed = true;
        }
        else
        {
          this.AccessAllowed = false;
        }

        localStorage.removeItem("screenMemoryBookingss");
        localStorage.removeItem("screenMemoryEvents");

        this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
          this.hubConnection = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + "/venue/" + this.VenueID, {
          accessTokenFactory: () => tokenReturned
        }).build();

        let menuItems: MenuItem[];

        let userid = localStorage.getItem("SmartUserID");

        this.BookingDate = new Date();

            //Get Settings and put them in Local Storage
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
              this.httpResponse =  (response as venuesettings_returndata)
              if(this.httpResponse.succeeded)
              {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

                this.httpResponse.data.venueSettings.forEach(element => {
                  localStorage.setItem(element.name, element.value);
                });

                this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
                this.loadgrid(false);
              }
              else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });

        });

      }
    });

    this.loadTags(false);
  }

  loadTags(showdisabled: boolean) {
    this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.tags = (response as tag_returndata).data;
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Could not load the tags to filter by.'});
    });
  }

  editdata(ID){
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  editdatanew(ID){
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  doReport(){

    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    let ReportToken = "";

    this.http.get(bmxurl + "/GetReportToken").subscribe(response => {
      ReportToken = (response as any).data;

      window.location.href = bmxurl + "/ExportBookingAnswerReport/" + this.VenueID + "/" + dateChosen + "/" + ReportToken;
    });



  }

  loadgrid(showdisabled: boolean)
  {
    //Opened here and closed on every way out below, so the spinner is balanced whichever path
    //the call takes. It used to be opened by ngOnInit and closed here, which left Go closing a
    //spinner it had never opened.
    this.busyService.busy();

    /*
      The same shape the Booking List report posts to /BookingList, dates and all, so the two
      are read the same way at the other end. disabled is what the old single-day URL always
      sent (its trailing /false).

      created picks which date the period is matched against. This report has always been by
      the day of the booking, so it stays that way unless it is deliberately changed - which is
      why it is a named constant rather than an unexplained literal.
    */
    let searchCrit = {
      venueid: this.VenueID,
      startdate: ConvertDateToDB(this.FromDate),
      enddate: ConvertDateToDB(this.ToDate),
      disabled: showdisabled,
      created: this.REPORTONCREATEDDATE,
      tags: this.chosentags
    };

    this.http.post(bmxurl + "/GetBookingAnswerReport", searchCrit).subscribe(response => {
      try{
        this.CreateUpdateResponse = (response as any);

        this.cols = [];

        if(this.CreateUpdateResponse.data.length > 0)
        {
          let importCols = Object.keys(this.CreateUpdateResponse.data[0]);

          importCols.forEach(element => {

            let column = new cColumninfo;
            column.field = element;
            column.header = element;

            this.cols.push(column)
         });

        }

        this.splitAdmissions(this.CreateUpdateResponse.data);

        this.guests = 0;
        this.total = 0;
        this.outstanding = 0;

        this.CreateUpdateResponse.data.forEach(element => {
          this.guests += element.Guests;
          this.total += Number(element.Total);
          this.outstanding += element.Outstanding;
        });

        this.ListBookingsGlobal = this.CreateUpdateResponse.data;
        const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        this.ListBookingsGlobal.forEach(row => {
          Object.keys(row).forEach(key => {
            if (typeof row[key] === 'string' && isoDatePattern.test(row[key])) {
              row[key] = this.formatDateForExcel(row[key]);
            }
          });
        });
      }
      catch (error){
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  /*
    Admissions arrive as a list of objects on each row. Shown as it comes that is one column
    reading [object Object], so it is split the way the Admission Report splits it: a column per
    admission type met in the period, holding how many of it the booking has, and a total of
    each for the footer. The columns go where the admissions column was, in the order the types
    are first met, so they do not move about between runs of the same report.

    The column is found by name whatever its capitals, because this report's columns are named
    by the API and the rest of them are capitalised.
  */
  private splitAdmissions(rows: any[]) {
    this.admissionTotals = {};

    if (rows == null || rows.length == 0) {
      return;
    }

    const source = this.cols.find(column => (column.field ?? "").toString().toLowerCase() == "admissions");

    if (source == null) {
      return;
    }

    const columns: { field: string, header: string }[] = [];

    const columnFor = (name: string) => {
      let found = columns.find(column => column.header == name);

      if (found == null) {
        //Not the name itself: a dot in a field is read by the table as a path.
        found = { field: "adm" + columns.length, header: name };
        columns.push(found);
        this.admissionTotals[found.field] = 0;
      }

      return found;
    };

    rows.forEach(row => {
      this.admissionsOn(row[source.field]).forEach(adm => {
        const column = columnFor(adm.name);

        row[column.field] = (Number(row[column.field]) || 0) + adm.people;
        this.admissionTotals[column.field] += adm.people;
      });

      //Taken off the row so the CSV export does not carry the raw list as well.
      delete row[source.field];
    });

    //A booking with none of an admission says 0 rather than leaving the cell empty. Done once
    //every row has been read, because a type first met on a later row is a column the earlier
    //rows did not know about.
    rows.forEach(row => {
      columns.forEach(column => {
        if (row[column.field] == null) {
          row[column.field] = 0;
        }
      });
    });

    const at = this.cols.indexOf(source);

    this.cols.splice(at, 1, ...columns.map(column => {
      let made = new cColumninfo;
      made.field = column.field;
      made.header = column.header;
      return made;
    }));
  }

  //The objects themselves, or the line the API used to write - "2 x Adults, 1 x Child" - in case
  //an older response is still about.
  private admissionsOn(value: any): { name: string, people: number }[] {
    if (Array.isArray(value)) {
      return value
        .map((adm: any) => ({
          name: (adm?.name ?? adm?.Name ?? "").toString().trim(),
          people: Number(adm?.noofpeople ?? adm?.NoOfPeople ?? adm?.noOfPeople ?? adm?.quantity ?? adm?.Quantity) || 0
        }))
        .filter(adm => adm.name != "" && adm.people > 0);
    }

    if (typeof value != "string" || value.trim() == "") {
      return [];
    }

    return value
      .split(",")
      .map(part => part.trim())
      .filter(part => part != "")
      .map(part => {
        const split = part.match(/^(\d+)\s*x\s*(.+)$/i);

        return split == null
          ? { name: part, people: 1 }
          : { name: split[2].trim(), people: Number(split[1]) || 0 };
      })
      .filter(adm => adm.name != "" && adm.people > 0);
  }

  //Whether a column is one of the split out admissions, for the table to centre it and the
  //footer to total it.
  isAdmissionColumn(field: string): boolean {
    return this.admissionTotals[field] != null;
  }

  /*
    Go. No longer follows the live booking events: those arrive per day, and a period could be
    weeks of them. It never actually refreshed anyway - the hub connection this listened on was
    built but never started. The Booking List report, which runs over a period the same way,
    does not listen either.
  */
  doneDate(){

    if (this.FromDate == null || this.ToDate == null) {
      this.messageService.add({severity:'warn', summary:'Dates needed', detail:'Choose both a From and a To date.'});
      return;
    }

    if (this.FromDate.getTime() > this.ToDate.getTime()) {
      this.messageService.add({severity:'warn', summary:'Dates the wrong way round', detail:'The From date is after the To date.'});
      return;
    }

    this.inProgress = false;

    this.loadgrid(false);
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();
  }

  exportData()
  {


  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  //The period cannot run backwards. Moving the From date past the To date takes the To date with
  //it, and the To picker will not open on anything earlier than the From date.
  fromDateChanged() {
    if (this.FromDate == null || this.ToDate == null) {
      return;
    }

    if (new Date(this.ToDate) < new Date(this.FromDate)) {
      this.ToDate = new Date(this.FromDate);
    }
  }
}
